import axiosInstance from '../axios';

export const fetchDashboardKPI = async (params = {}) => {
  const response = await axiosInstance.get('/owner/dashboard/kpi', { params });
  return response.data.data;
};

export const fetchDashboardSales = async (params = {}) => {
  const response = await axiosInstance.get('/owner/dashboard/sales', { params });
  return response.data.data;
};

export const fetchDashboardLeads = async (params = {}) => {
  const response = await axiosInstance.get('/owner/dashboard/leads', { params });
  return response.data.data;
};

export const fetchDashboardPropertyPerformance = async (params = {}) => {
  const response = await axiosInstance.get('/owner/dashboard/property-performance', { params });
  return response.data.data;
};
